import { WebIframeSettings } from '../types/settingsTypes';
import LocalStorageUtils from './local-storage';

const WEB_IFRAME_SETTINGS_STORAGE_KEY = 'webIframeSettings';

const normalizeWebIframeSettings = (settings: Partial<WebIframeSettings> | null | undefined): WebIframeSettings => {
  return {
    ...new WebIframeSettings(),
    ...(settings || {})
  };
};

const persistWebIframeSettings = (settings: WebIframeSettings): void => {
  try {
    LocalStorageUtils.putValueToLocalStorage(WEB_IFRAME_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // Ignore storage errors: runtime state still updates through Redux.
  }
};

export const cacheWebIframeSettings = (settings: Partial<WebIframeSettings>): WebIframeSettings => {
  const normalizedSettings = normalizeWebIframeSettings(settings);

  persistWebIframeSettings(normalizedSettings);

  return normalizedSettings;
};

export const getCachedWebIframeSettings = (): WebIframeSettings | null => {
  try {
    const rawSettings = LocalStorageUtils.getValueFromLocalStorage(WEB_IFRAME_SETTINGS_STORAGE_KEY);

    if (!rawSettings) {
      return null;
    }

    const parsedSettings = JSON.parse(rawSettings) as Partial<WebIframeSettings> | null;

    if (!parsedSettings || typeof parsedSettings !== 'object') {
      return null;
    }

    return normalizeWebIframeSettings(parsedSettings);
  } catch {
    return null;
  }
};
